import { render, staticRenderFns } from "./ModalCross.vue?vue&type=template&id=7567f08d&"
var script = {}
import style0 from "./ModalCross.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports